<style scoped lang="scss">
@import '@/assets/scss/_inputs-shared.scss';
</style>
<template>
    <div>
        <div class="step5-container">
            
            <!-- ApoderadoForm - always shown, but disabled after completion -->
            <ApoderadoForm 
                @apoderado-form-completed="handleApoderadoCompleted"
                @go-back="handleGoBack"
                :disabled="apoderadoCompleted"
                :completed="apoderadoCompleted"
                :show-button-continue="!showStudentForm"
                :initial-data="financingPartyData"
                ref="apoderadoForm"
            />

        
            <StudentForm 
                v-if="showStudentForm" 
                @form-completed="handleStudentCompleted"
                @go-back="$emit('previous-step')"
                :student-email="stepperData.step2?.email || ''"
                :initial-data="getStudentInitialData()"
                :stepper-data="stepperData"
                class="student-form-section"
                ref="studentForm"
            />


        </div>

        <!-- Modal de Procesamiento de Pago -->
        <div v-if="processingModal" class="modal-intensive" id="modalIntensive">
            <div class="content realtive">
                <div class="text-content">
                    <div class="d-flex justify-content-center mb-4">
                        <img
                            src="/images/featured/wait-icon.svg"
                            alt="IconButtonRelod"
                        />
                    </div>
                    <h5>Espera un momento mientras procesamos tu solicitud</h5>
                    <p>Esto puede demorar unos segundos.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApoderadoForm from '@/components/step5/ApoderadoForm.vue'
import StudentForm from '@/components/step5/StudentForm.vue'
import localPageTimerMixin from '@/mixins/localPageTimerMixin'

import { studentsService, ordersService, financingPartiesService } from '@/services'
import { useStepperStore } from '@/store/stepperStore'

export default {
    name: 'NewVersionStep5',
    mixins: [localPageTimerMixin],
    components: {
        ApoderadoForm,
    StudentForm
    },
    setup() {
        const stepperStore = useStepperStore()
        return { stepperStore }
    },
    props: {
        stepperData: {
            type: Object,
            required: true
        }
    },
                data() {
                return {
                    apoderadoCompleted: false,
                    studentCompleted: false,
                    dataLoaded: false, // Flag para controlar cuando los datos están cargados
                    showStudentForm: false, // New state variable to control student form visibility
                    // Modal state
                    processingModal: false, // Modal de procesamiento de pago
                                financingPartyData: {
                        id: null, // Agregar campo id
                        name: "",
                        fatherLastName: null,
                        motherLastName: null,
                        lastName: null,
                        rut: "",
                        email: null,
                        phone: "+56 ",
                        regionId: null,
                        cityId: null,
                        communeId: null,
                        address: null,
                        address2: null,
                        address3: null,
                    },
                    studentData: {
                        email: "",
                        phone: "+56 ",
                        birthDate: "",
                        averageScore: "",
                        schoolRegionId: null,
                        schoolCommuneId: null,
                        schoolId: null,
                        schoolName: null,
                        graduationYear: null
                    }
        }
    },
        mounted() {
        // Cargar datos guardados del store de forma asíncrona
            (async () => {
                this.loadSavedData();
                // Verificar si es un retorno desde Transbank o transacción fallida
                this.handleTransbankReturn();
            })();
            
            // Agregar event listeners específicos para detectar actividad en formularios
            this.$nextTick(() => {
                const forms = document.querySelectorAll('form, input, select, textarea');
                forms.forEach(element => {
                    element.addEventListener('input', this.resetInactivityTimer);
                    element.addEventListener('change', this.resetInactivityTimer);
                    element.addEventListener('focus', this.resetInactivityTimer);
                });
            });
        },
            computed: {
                isFormFullyLoaded() {
                    // Verificar si todos los campos requeridos del financingPartyData están llenos
                    const requiredFields = [
                        'name', 'fatherLastName', 'motherLastName', 'rut', 
                        'email', 'phone', 'address', 'address2', 'address3',
                        'regionId', 'cityId', 'communeId'
                    ];
                    
                    const isFullyLoaded = requiredFields.every(field => {
                        const value = this.financingPartyData[field];
                        if (field === 'regionId' || field === 'cityId' || field === 'communeId') {
                            return value && value !== null && value !== undefined && value !== '';
                        } else {
                            return value && value.toString().trim() !== '';
                        }
                    });
                    
                    return isFullyLoaded;
                },
                hasIncompleteData() {
                    // Si no hay datos guardados, no deshabilitar el formulario
                    if (!this.financingPartyData || Object.keys(this.financingPartyData).length === 0) {
                        return false;
                    }
                    
                    // Verificar si hay algún campo requerido que no esté lleno
                    const requiredFields = [
                        'name', 'fatherLastName', 'motherLastName', 'rut', 
                        'email', 'phone', 'address', 'address2', 'address3',
                        'regionId', 'cityId', 'communeId'
                    ];
                    
                    const hasIncomplete = requiredFields.some(field => {
                        const value = this.financingPartyData[field];
                        if (field === 'regionId' || field === 'cityId' || field === 'communeId') {
                            return !value || value === null || value === undefined || value === '';
                        } else {
                            return !value || value.toString().trim() === '';
                        }
                    });
                    
                    return hasIncomplete;
                }
            },
            watch: {

        // Watch for stepperData changes to log email
        'stepperData.step2.email': function() {
            // Email detected
        },
        // Watch for stepperData changes
        stepperData: {
            handler(newVal) {
                // Recargar datos si step5 cambia
                if (newVal) {
                    this.loadSavedData();
                }
            },
            deep: true
        }
    },
    methods: {
        // Método para reiniciar el timer de inactividad cuando el usuario interactúa
        resetInactivityTimer() {
            if (this.resetTimer) {
                this.resetTimer();
            }
        },
        handleStudentCompleted(data) {
            this.studentCompleted = true
            
            // Guardar los datos del estudiante
            this.studentData = {
                studentName: data.studentName || '',
                rut: data.rut || '',
                email: data.email || this.stepperData.step2?.email || '',
                phoneNumber: data.phoneNumber || '',
                // Construir teléfono completo para compatibilidad
                phone: data.phoneNumber ? `+56 ${data.phoneNumber}` : '+56 ',
                birthDate: data.birthDate || '',
                averageScore: data.averageScore ? data.averageScore.replace(/,/g, '.') : '',
                schoolRegionId: data.schoolRegionId || null,
                schoolCommuneId: data.schoolCommuneId || null,
                schoolId: data.schoolId || null,
                schoolName: data.schoolName || null,
                graduationYear: data.graduationYear || null,
                authorizationPublicitary: true
            };
            
            // Actualizar el Step2 con el celular del estudiante
            this.updateStep2WithStudentPhone();
            
            // Guardar en el store ANTES de iniciar el proceso de pago
            this.saveToStore();
            
            // Iniciar proceso de pago
            this.startPaymentProcess();
        },
        validEmail(email) {
            var re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
            return re.test(email);
        },
        

        

        
        checkEmail() {
            this.otp_valid = false;

            if (
                this.financingPartyData.name == "" ||
                this.financingPartyData.rut == "" ||
                !this.validEmail(this.financingPartyData.email)
            ) {
                return;
            }

            // This method now only validates email format, doesn't create financing party
            // The modal will be shown by createFinancingPartyAndShowModal after successful creation
        },

        async handleApoderadoCompleted(data) {
            
            // Verificar si el apoderado existe y crear/actualizar según corresponda
            try {
                const financingPartyResult = await this.handleFinancingPartyCreation(data);
                
                if (!financingPartyResult) {
                    return;
                }
                
                // Store the complete financing party data with the ID returned from the API
                this.financingPartyData = {
                    id: financingPartyResult.id,
                    name: data.name || "",
                    fatherLastName: data.fatherLastName || null,
                    motherLastName: data.motherLastName || null,
                    lastName: data.lastName || null,
                    rut: data.rut || "",
                    email: data.email || null,
                    phone: data.phone || "+56 ",
                    regionId: data.regionId || null,
                    cityId: data.cityId || null,
                    communeId: data.communeId || null,
                    address: data.address || null,
                    address2: data.address2 || null,
                    address3: data.address3 || null
                };
                
                
                // Mark apoderado as completed
                this.apoderadoCompleted = true;
                
                // Show student form
                this.showStudentForm = true;
                
                // Save to store
                this.saveToStore();
                
                // Scroll automático hacia el StudentForm después de un pequeño delay
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.scrollToStudentForm();
                    }, 300); // Delay de 300ms para asegurar que el DOM se haya actualizado
                });
                
                
            } catch (error) {
                console.error('❌ Error en handleApoderadoCompleted:', error);
                this.$swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Error al procesar datos",
                    text: "Hubo un problema al procesar los datos del apoderado. Por favor, intenta nuevamente.",
                    showConfirmButton: true,
                });
            }
        },

        // Método para manejar la creación/actualización del apoderado
        async handleFinancingPartyCreation(formData) {
            try {
                // Preparar los datos del apoderado para la API
                const financingPartyData = {
                    name: formData.name || "",
                    fatherLastName: formData.fatherLastName || null,
                    motherLastName: formData.motherLastName || null,
                    lastName: formData.lastName || null,
                    rut: formData.rut || "",
                    email: formData.email || null,
                    phone: formData.phone || "+56 ",
                    regionId: formData.regionId || null,
                    cityId: formData.cityId || null,
                    communeId: formData.communeId || null,
                    address: formData.address || null,
                    address2: formData.address2 || null,
                    address3: formData.address3 || null
                };
                
                let existingFinancingParty = null;
                
                try {
                    // Verificar si el apoderado existe por email usando el servicio
                    const response = await financingPartiesService.checkFinancingPartyByEmail(
                        formData.email
                    );
                    existingFinancingParty = response.data;
                } catch (checkError) {
                    
                    // Si el error es 404, significa que el apoderado no existe
                    if (checkError.response && checkError.response.status === 404) {
                        existingFinancingParty = null;
                    } else {
                        // Si es otro error, re-lanzarlo
                        throw checkError;
                    }
                }
                
                if (existingFinancingParty && existingFinancingParty.id) {
                    // El apoderado existe, verificar si hay cambios
                    const hasChanges = this.checkFinancingPartyChanges(existingFinancingParty, financingPartyData);
                    
                    if (hasChanges) {
                        // Actualizar el apoderado existente usando el servicio
                        const { data: updatedFinancingParty } = await financingPartiesService.updateFinancingParty(
                            existingFinancingParty.id,
                            financingPartyData
                        );
                        return updatedFinancingParty;
                    } else {
                        return existingFinancingParty;
                    }
                } else {
                    // Crear nuevo apoderado usando el servicio
                    const { data: newFinancingParty } = await financingPartiesService.createFinancingParty(
                        financingPartyData
                    );
                    return newFinancingParty;
                }
                
            } catch (error) {
                console.error('❌ Error en handleFinancingPartyCreation:', error);
                console.error('📊 Detalles del error:', {
                    status: error.response?.status,
                    data: error.response?.data,
                    message: error.message
                });
                
                // Manejar errores específicos
                if (error.response && error.response.status === 400) {
                    if (error.response.data.message === "email must be unique") {
                        this.$swal.fire({
                            position: "center",
                            icon: "warning",
                            title: "¡Atención!",
                            html: `El correo <b>${formData.email}</b> ya se encuentra registrado`,
                            showConfirmButton: true,
                            confirmButtonText: "Aceptar"
                        });
                    } else {
                        this.$swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error de validación",
                            text: error.response.data.message || "Error al procesar los datos del apoderado",
                            showConfirmButton: true,
                            confirmButtonText: "Aceptar"
                        });
                    }
                } else {
                    this.$swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Error del servidor",
                        text: "Hubo un problema al procesar los datos del apoderado. Por favor, intenta nuevamente.",
                        showConfirmButton: true,
                        confirmButtonText: "Aceptar"
                    });
                }
                
                return false;
            }
        },

        handleGoBack() {
            // Emitir evento para ir al paso anterior
            this.$emit('previous-step');
        },


        // Cargar datos guardados del store
        loadSavedData() {
            if (this.stepperData) {
                const savedData = this.stepperData;
                
                // Cargar estado del apoderado
                if (savedData.apoderadoCompleted !== undefined) {
                    this.apoderadoCompleted = savedData.apoderadoCompleted;
                }
                
                // Cargar estado del estudiante
                if (savedData.studentCompleted !== undefined) {
                    this.studentCompleted = savedData.studentCompleted;
                }
                
                // Cargar estado del formulario de estudiante
                if (savedData.showStudentForm !== undefined) {
                    this.showStudentForm = savedData.showStudentForm;
                }
                
                // Cargar datos del apoderado
                if (savedData.financingPartyData && Object.keys(savedData.financingPartyData).length > 0) {
                    this.financingPartyData = { ...this.financingPartyData, ...savedData.financingPartyData };
                }
                
                // Cargar datos del estudiante
                if (savedData.studentData && Object.keys(savedData.studentData).length > 0) {
                    this.studentData = { ...this.studentData, ...savedData.studentData };
                }
                
                // Cargar estado de validación de email
                if (savedData.emailValidated !== undefined) {
                    this.otp_valid = savedData.emailValidated;
                }
                
                this.dataLoaded = true;
            } else {
                this.dataLoaded = true; // También marcar como cargado si no hay datos
            }
        },

        // Guardar datos en el store
        saveToStore() {
            const step5Data = {
                apoderadoCompleted: this.apoderadoCompleted,
                studentCompleted: this.studentCompleted,
                showStudentForm: this.showStudentForm,
                financingPartyData: this.financingPartyData,
                studentData: this.studentData,
                emailValidated: this.otp_valid,
                completed: this.apoderadoCompleted && this.studentCompleted
            };
            
            this.$emit('update-data', step5Data);
        },

        // Iniciar proceso de pago siguiendo el patrón del outlet
        async startPaymentProcess() {
            try {
                // Verificar que los datos requeridos estén disponibles
                if (!this.stepperData || !this.stepperData.step2 || !this.stepperData.step3 || !this.stepperData.step4) {
                    throw new Error('Datos de los pasos anteriores no están disponibles. Por favor, completa los pasos anteriores primero.');
                }
                
                this.processingModal = true;
                
                // Verificar si el estudiante ya existe
                const existingStudentId = this.stepperData.step2.studentId;
                
                // 1. Actualizar el estudiante con los datos del paso 5 ANTES de actualizar la orden
                if (existingStudentId) {
                    const studentData = this.buildStudentData();
                    await studentsService.updateStudent(existingStudentId, studentData);
                }
                
                // 2. Actualizar orden con el sessionState actualizado
                const orderData = await this.buildOrderData(existingStudentId);
                // Usar datos encriptados para el envío
                const encryptedStepperData = this.stepperStore.getEncryptedData();
                const orderResponse = await ordersService.updateOrder(orderData, encryptedStepperData);
                
                // 3. Actualizar estudiante con financingPartyId y caretakerId de la respuesta
                if (existingStudentId && orderResponse.financingPartyId && orderResponse.caretakerId) {
                    const data = this.buildStudentData();
                    data.financingPartyId = orderResponse.financingPartyId;
                    data.caretakerId = orderResponse.caretakerId;
                    await studentsService.updateStudent(existingStudentId, data);
                }
                
                // 4. Redirigir a Transbank
                this.redirectToTransbank(orderResponse);
                
            } catch (error) {
                console.error('Error en el proceso de pago:', error);
                this.processingModal = false;
                
                // Extract error message from backend response
                let errorMessage = "Hubo un problema al procesar tu solicitud. Por favor, intenta nuevamente.";
                let errorTitle = "Error en el proceso";
                
                if (error.response && error.response.data) {
                    // Check for different error message formats
                    if (error.response.data.message) {
                        errorMessage = error.response.data.message;
                        // Set specific title for RUT duplicate errors
                        if (error.response.data.message.includes("Ya existe un estudiante registrado con ese RUT")) {
                            errorTitle = "RUT duplicado";
                        }
                    } else if (error.response.data.error) {
                        errorMessage = error.response.data.error;
                    } else if (typeof error.response.data === 'string') {
                        errorMessage = error.response.data;
                    }
                } else if (error.message) {
                    errorMessage = error.message;
                }
                
                this.$swal.fire({
                    position: "center",
                    icon: "error",
                    title: errorTitle,
                    text: errorMessage,
                    showConfirmButton: true,
                    confirmButtonText: "Aceptar"
                });
            }
        },

        // Actualizar Step2 con el celular del estudiante
        updateStep2WithStudentPhone() {
            if (this.studentData && this.studentData.phoneNumber) {
                // Actualizar el Step2 en el store con el celular del estudiante
                const step2Update = {
                    phoneNumber: this.studentData.phoneNumber
                };
                
                this.$emit('update-step2', step2Update);
            }
        },

        // Construir datos del estudiante
        buildStudentData() {
            const step2 = this.stepperData?.step2 || {};
            const step3 = this.stepperData?.step3 || {};
            const step4 = this.stepperData?.step4 || {};
            const step5 = this.stepperData?.step5 || {};
            
            // Usar datos del estudiante del estado local (datos actualizados del formulario)
            const studentData = this.studentData || {};
            
            // Verificar que los datos requeridos estén disponibles
            if (!step2 || !step3 || !step4) {
                throw new Error('Datos de los pasos anteriores no están disponibles');
            }
            
            
            // Obtener datos del apoderado para completar información faltante
            const financingPartyData = this.financingPartyData || step5?.financingPartyData || {};
            
            // Construir objeto completo del estudiante con valores por defecto apropiados
            const studentPayload = {
                // Datos básicos del estudiante (priorizar datos del paso 5 si están disponibles)
                name: this.extractFirstName(studentData.studentName || step2.firstName || ''),
                fatherLastName: step2.firstLastName || '',
                lastName: step2.secondLastName || '',
                rut: studentData.rut || step2.rut || '',
                email: studentData.email || step2.email || '',
                phone: studentData.phone || step2.phone || "+56 ",
                
                // Datos de ubicación (usar datos del apoderado si no están disponibles)
                cityId: step2.cityId || financingPartyData.cityId || null,
                communeId: step2.communeId || financingPartyData.communeId || null,
                address: step2.address || financingPartyData.address || '',
                address2: step2.address2 || financingPartyData.address2 || '',
                address3: step2.address3 || financingPartyData.address3 || '',
                
                // Datos académicos
                // Formatear fecha de nacimiento a formato YYYY-MM-DD
                birthday: this.formatBirthday(studentData.birthDate || step2.birthDate),
                establishment: step3.selectedSede,
                graduationYear: studentData.graduationYear || step2.graduationYear || null,
                averageScore: this.formatAverageScore((studentData.averageScore || step2.averageScore || '').replace(/,/g, '.')),
                
                // Datos específicos del programa
                careerPath: "pdv",
                pdvId: step2.studentId || null,
                preferredVenue: step2.preferredLocation || null,
                
                // Datos del programa
                program: step3.program || null,
                
                // Datos de selección
                selectedSubjects: step3.selectedSubjects || [],
                selectedLocation: step2.preferredLocation || null,
                selectedCourses: step3.selectedCourses || [],
                
                // Datos de precios
                prices: step4.quote || null,
                
                // Datos específicos del colegio del paso 5
                schoolRegionId: studentData.schoolRegionId || null,
                schoolCommuneId: studentData.schoolCommuneId || null,
                schoolId: studentData.schoolId || null,
                schoolName: studentData.schoolName || null,
                
                // Autorización publicitaria
                authorizationPublicitary: true,
                
                // Datos adicionales que pueden estar en el JSON
                caretakerId:  null,
                financingPartyId: this.financingPartyData?.id || step5?.financingPartyData?.id || null,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString()
            };
            
            return studentPayload;
        },

    // Construir datos de la orden
    async buildOrderData(studentId) {
            const step1 = this.stepperData?.step1 || {};
            const step2 = this.stepperData?.step2 || {};
            const step3 = this.stepperData?.step3 || {};
            const step4 = this.stepperData?.step4 || {};
            const step5 = this.stepperData?.step5 || {};
            
            // Usar datos del estudiante del estado local (datos actualizados del formulario)
            const studentData = this.studentData || {};
            
            // Verificar que los datos requeridos estén disponibles
            if (!step1 || !step2 || !step3 || !step4) {
                throw new Error('Datos de los pasos anteriores no están disponibles');
            }

             //Obtener el source desde query params route
            const SOURCE = this.$route.query.utm_source || 'directo';
            const MEDIUM = this.$route.query.utm_medium || 'none';
            const CAMPAIGN = this.$route.query.utm_campaign || 'none';
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            const DEVICE = isMobile ? 'Mobile' : 'Desktop';
            
                        // Construir objeto de la orden siguiendo exactamente la estructura del SessionState.json
            const orderData = {
                // SessionState con estructura completa como en SessionState.json
                sessionState: JSON.stringify({
                    students: [{
                        // Programa completo con todos sus detalles (desde Step1)
                        program: this.buildProgramData(this.stepperData),
                        // Datos del estudiante según SessionState.json
                        id: studentId,
                        caretakerId: this.financingPartyData?.id || step5?.financingPartyData?.id || null,
                        financingPartyId: this.financingPartyData?.id || step5?.financingPartyData?.id || null,
                        name: this.extractFirstName(studentData.studentName || step2.firstName || ''),
                        fatherLastName: step2.firstLastName || '',
                        lastName: step2.secondLastName || '',
                        rut: studentData.rut || step2.rut || '',
                        email: studentData.email || step2.email || '',
                        phone: studentData.phone || step2.phone || "+56 ",
                        cityId: step2.cityId || null,
                        birthday: this.formatBirthday(studentData.birthDate || step2.birthDate),
                        communeId: step2.communeId || null,
                        address: step2.address || null,
                        address2: step2.address2 || null,
                        address3: step2.address3 || null,
                        establishment: step2.establishment || '',
                        graduationYear: studentData.graduationYear || step2.graduationYear || null,
                        averageScore: studentData.averageScore || step2.averageScore || null,
                        careerPath: "pdv",
                        pdvId: step2.studentId || null,
                        createdAt: new Date().toISOString(),
                        updatedAt: new Date().toISOString(),
                        // Campos adicionales según SessionState.json
                        CaretakerId: this.financingPartyData?.id || step5?.financingPartyData?.id || null,
                        FinancingPartyId: this.financingPartyData?.id || step5?.financingPartyData?.id || null,
                        CityId: studentData.cityId || step2.cityId || null,
                        CommuneId: studentData.communeId || step2.communeId || null,
                        // Datos de ubicación anidados
                        Commune: studentData.commune || null,
                        preferredVenue: step2.preferredLocation || null,
                        // Datos de selección según SessionState.json (desde Step3)
                        selectedSubjects: step3.selectedSubjects || [],
                        selectedLocation: {
                            ...step2.preferredLocation,
                            commerceCode: step3.selectedSede ? this.getSedeCommerceCode(step3.selectedSede) : null
                        },
                        selectedCourses: await this.buildSelectedCoursesComplete(this.stepperData),
                        // Datos de precios según SessionState.json (desde Step4)
                        prices: step4.quote || null,
                        // Datos específicos del colegio del paso 5
                        schoolRegionId: studentData.schoolRegionId || null,
                        schoolCommuneId: studentData.schoolCommuneId || null,
                        schoolId: studentData.schoolId || null,
                        schoolName: studentData.schoolName || null,
                        //Estableciento es el rbd del colegio
                        // Autorización publicitaria
                        authorizationPublicitary: true
                    }]
                }),
                // OrderDetails siguiendo la estructura de los pasos antiguos
                orderDetails: [{
                    locationId: step3.selectedSede,
                    programId: step2.selectedProgramId,
                    coursesIds: [...new Set(step3.selectedCourses.map(course => course.id))],
                    studentId: studentId
                }],
                // Propiedades adicionales como en los pasos antiguos
                coupon: step4.coupon || null, // Se puede agregar si hay cupón
                rut: this.financingPartyData?.rut || step5?.financingPartyData?.rut || '',
                financingParty: this.financingPartyData || step5?.financingPartyData || null,
                source: SOURCE,
                medium: MEDIUM,
                campaign: CAMPAIGN,
                device: DEVICE,
                authorizationPublicitary: true
            };
            return orderData;
        },


        buildProgramData(stepperData) {
            const step1 = stepperData?.step1 || {};
            const step3 = stepperData?.step3 || {};
            const location = step1.program.Locations.find(location => location.id === step3.selectedSede);
            step1.program.Locations = [location];
            return step1.program;
        },
        // Construir estructura completa de selectedCourses con todas las propiedades requeridas
        async buildSelectedCoursesComplete(stepperData) {
            const step3 = stepperData?.step3 || {};
            const selectedCourses = step3.selectedCourses || [];
            const allMaterias = [...(step3.leftColumnMaterias || []), ...(step3.rightColumnMaterias || [])];
            const courses = allMaterias.flatMap(m => m.courses || []);
            
            // Crear un Set para rastrear IDs únicos de cursos
            const uniqueCourseIds = new Set();
            
            return selectedCourses
                .filter(selection => {
                    // Solo incluir cursos que no hayan sido procesados antes
                    if (uniqueCourseIds.has(selection.id)) {
                        return false;
                    }
                    uniqueCourseIds.add(selection.id);
                    return true;
                })
                .map(selection => {
                    const course = courses.find(m => parseInt(m.id) === parseInt(selection.id));
                    
                    // Verificar que el curso exista antes de procesarlo
                    if (!course) {
                        console.warn(`Curso con ID ${selection.id} no encontrado`);
                        return null;
                    }
                    
                    const days = course.Schedules.map(schedule => schedule.dayOfWeek).filter(Boolean);
                    const blocks = course.Schedules.map(schedule => schedule.block).filter(Boolean);
                    const schedulesPerDayOfThisCourse = course.Schedules.map(schedule =>
                        `${schedule.dayOfWeek} ${schedule.startTime?.slice(0, 5)}-${schedule.endTime?.slice(0, 5)}`
                    ).filter(Boolean);
                    const hoursPerDay = course.Schedules.map(schedule => ({
                        day: schedule.dayOfWeek,
                        startTime: schedule.startTime,
                        endTime: schedule.endTime,
                        block: schedule.block,
                        courseId: course.id,
                        scheduleId: schedule.id,
                        subject: course.Subject?.name,
                    })).filter(Boolean);
                    const hour = schedulesPerDayOfThisCourse.join(', ');
                    
                    return {
                        courseId: selection.id,
                        hour: hour,
                        lastSeats: false,
                        days: days,
                        subjectName: selection.name,
                        iconSrc: ``,
                        coursePdvId: course.pdvId || course.id,
                        coursePdvCode: course.pdvCode || course.codigo || `CODE${course.id}`,
                        subjectId: course.SubjectId || course.subjectId || course.subjectId,
                        blocks: blocks,
                        schedulesPerDayOfThisCourse: schedulesPerDayOfThisCourse,
                        coursesWithSameSchedule: [],
                        hoursPerDay: hoursPerDay
                    };
                })
                .filter(Boolean); // Filtrar elementos nulos
        },

        buildSelectedCourses() {
            return {
                schedulesPerDayOfThisCourse: '',
                subjectName: '',
                hoursPerDay: '',
                pdvCode: '',
            };
        },

        // Formatear NEM (cambiar comas por puntos)
        formatAverageScore(averageScore) {
            if (!averageScore) return null;
            
            // Convertir a string si no lo es
            const scoreString = String(averageScore);
            
            // Reemplazar comas por puntos
            const formattedScore = scoreString.replace(',', '.');
            
            // Convertir a número para validar que sea un número válido
            const numericScore = parseFloat(formattedScore);
            
            // Retornar el número formateado o null si no es válido
            return isNaN(numericScore) ? null : numericScore;
        },

        // Formatear fecha de nacimiento a formato YYYY-MM-DD
        formatBirthday(birthDate) {
            if (!birthDate) return null;
            
            // Convertir a string si no lo es
            const dateString = String(birthDate);
            
            // Si ya está en formato YYYY-MM-DD, retornarlo tal como está
            if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
                return dateString;
            }
            
            // Si está en formato DD/MM/YYYY o DD-MM-YYYY, convertirlo
            let day, month, year;
            
            if (dateString.includes('/')) {
                // Formato DD/MM/YYYY
                const parts = dateString.split('/');
                if (parts.length === 3) {
                    [day, month, year] = parts;
                }
            } else if (dateString.includes('-')) {
                // Formato DD-MM-YYYY
                const parts = dateString.split('-');
                if (parts.length === 3) {
                    [day, month, year] = parts;
                }
            }
            
            // Validar que tenemos los componentes necesarios
            if (day && month && year) {
                // Asegurar que el año tenga 4 dígitos
                const fullYear = year.length === 2 ? `20${year}` : year;
                // Asegurar que mes y día tengan 2 dígitos
                const paddedMonth = month.padStart(2, '0');
                const paddedDay = day.padStart(2, '0');
                
                return `${fullYear}-${paddedMonth}-${paddedDay}`;
            }
            
            // Si no se puede parsear, retornar null
            console.warn('No se pudo formatear la fecha de nacimiento:', birthDate);
            return null;
        },
        
        // Extraer solo el primer nombre del estudiante
        extractFirstName(fullName) {
            if (!fullName) return '';
            
            // Convertir a string si no lo es
            const nameString = String(fullName);
            
            // Dividir por espacios y tomar el primer elemento
            const nameParts = nameString.trim().split(' ');
            return nameParts[0] || '';
        },

        // Obtener el código de comercio de la sede seleccionada
        getSedeCommerceCode(sedeId) {
            try {
                const step1 = this.stepperData?.step1 || {};
                const step3 = this.stepperData?.step3 || {};
                
                // Buscar la sede en las ubicaciones del programa
                if (step1.program && step1.program.Locations) {
                    const sede = step1.program.Locations.find(location => location.id === sedeId);
                    if (sede && sede.commerceCode) {
                        return sede.commerceCode;
                    }
                }
                
                // Si no se encuentra en step1, buscar en step3
                if (step3.selectedSede && step3.selectedSedeData) {
                    const sedeData = step3.selectedSedeData;
                    if (sedeData.commerceCode) {
                        return sedeData.commerceCode;
                    }
                }
                
                console.warn('⚠️ No se encontró código de comercio para la sede:', sedeId);
                return null;
            } catch (error) {
                console.error('❌ Error al obtener código de comercio de la sede:', error);
                return null;
            }
        },

        // Verificar si hay cambios en los datos del apoderado
        checkFinancingPartyChanges(existingFinancingParty, formData) {
            const currentData = formData;
            const existingData = existingFinancingParty;
            
            // Comparar campos relevantes
            const fieldsToCompare = [
                'name', 'fatherLastName', 'motherLastName', 'lastName', 
                'rut', 'email', 'phone', 'communeId', 'address', 'address2', 'address3'
            ];
            
            for (const field of fieldsToCompare) {
                const currentValue = currentData[field];
                const existingValue = field === 'communeId' ? existingData.commune : existingData[field];
                
                if (currentValue !== existingValue) {
                    return true;
                }
            }
            
            return false;
        },

        // Manejar retorno desde Transbank
        handleTransbankReturn() {
            // Verificar si hay parámetros de retorno en la URL
            const urlParams = new URLSearchParams(window.location.search);
            const buyOrder = urlParams.get('buyOrder');
            const orderId = urlParams.get('no');
            const transactionFailed = urlParams.get('transactionFailed');
            
            // Manejar transacción fallida
            if (transactionFailed) {
                const errName = transactionFailed;
                if (errName === "err" || errName === "time_expired") {
                    // Redirigir a la página de compra rechazada del nuevo sistema
                    window.location.replace(
                        `/informacion-compra-rechazada?buyOrder=${buyOrder}&no=${orderId}`
                    );
                    return; // Salir para evitar la redirección a compra exitosa
                }
            }
            
            // Si hay buyOrder y orderId sin error, es una transacción exitosa
            if (buyOrder && orderId && !transactionFailed) {
                // Redirigir a la página de información de compra exitosa del nuevo sistema
                window.location.replace(
                    `/compra-confirmada?buyOrder=${buyOrder}&no=${orderId}`
                );
            }
        },

        // Manejar fallo de transacción
        handleTransactionFailure(errName) {
            // Mostrar modal de error
            this.$swal.fire({
                position: "center",
                icon: "error",
                title: "Error en la transacción",
                text: errName === "time_expired" 
                    ? "La transacción ha expirado. Por favor, intenta nuevamente."
                    : "Ha ocurrido un error en la transacción. Por favor, intenta nuevamente.",
                showConfirmButton: true,
                confirmButtonText: "Aceptar"
            });
            
            // Resetear el estado del formulario para permitir reintentar
            this.processingModal = false;
            
            // Opcional: Resetear algunos datos para permitir reintentar el pago
            this.studentCompleted = false;
            this.apoderadoCompleted = false;
        },

        // Redirigir a Transbank
        redirectToTransbank(orderResponse) {
            this.processingModal = false;
            
            // Verificar si el cupón es del 100% (precioTotal = 0)
            const step4 = this.stepperData?.step4 || {};
            const prices = step4.quote || {};
            const isFreeOrder = prices.precioTotal === 0 || prices.precioTotal === '0';
            
            
            if (isFreeOrder) {
                // Si es orden gratuita (cupón 100%), redirigir directamente a información de compra
                if (orderResponse.buyOrder && orderResponse.order && orderResponse.order.id) {
                    window.location.replace(
                        `/informacion-compra?buyOrder=${orderResponse.buyOrder}&no=${orderResponse.order.id}`
                    );
                } else {
                    // Fallback para orden gratuita sin datos de orden
                    this.$swal.fire({
                        position: "center",
                        icon: "success",
                        title: "¡Proceso completado!",
                        text: "Tu solicitud ha sido procesada exitosamente.",
                        showConfirmButton: true,
                        confirmButtonText: "Aceptar"
                    });
                }
            } else if (orderResponse.url && orderResponse.token) {
                // Si no es gratuita y hay URL de Transbank, crear formulario para enviar a Transbank
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = orderResponse.url;
                form.style.display = 'none';
                
                const tokenInput = document.createElement('input');
                tokenInput.type = 'hidden';
                tokenInput.name = 'token_ws';
                tokenInput.value = orderResponse.token;
                form.appendChild(tokenInput);
                
                document.body.appendChild(form);
                form.submit();
            } else {
                // Si no hay URL de Transbank, redirigir a la página de información de compra
                if (orderResponse.buyOrder && orderResponse.order && orderResponse.order.id) {
                    window.location.replace(
                        `informacion-compra?buyOrder=${orderResponse.buyOrder}&no=${orderResponse.order.id}`
                    );
                } else {
                    // Fallback: mostrar mensaje de éxito
                    this.$swal.fire({
                        position: "center",
                        icon: "success",
                        title: "¡Proceso completado!",
                        text: "Tu solicitud ha sido procesada exitosamente.",
                        showConfirmButton: true,
                        confirmButtonText: "Aceptar"
                    });
                }
            }
                 },

        // Método para hacer scroll automático hacia el StudentForm
        scrollToStudentForm() {
            try {
                // Buscar el elemento StudentForm por su clase o ID
                const studentFormElement = document.querySelector('.student-form-section');
                
                if (studentFormElement) {
                    // Hacer scroll suave hacia el StudentForm
                    studentFormElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });
                    
                    console.log('✅ Scroll automático hacia StudentForm ejecutado');
                } else {
                    console.warn('⚠️ No se encontró el elemento StudentForm para hacer scroll');
                }
            } catch (error) {
                console.error('❌ Error al hacer scroll hacia StudentForm:', error);
            }
        },

        // Método para obtener datos iniciales del estudiante combinando paso 2 y paso 5
        getStudentInitialData() {
            const step2 = this.stepperData?.step2 || {};
            const step5StudentData = this.studentData || {};
            
            
            // Construir nombre completo del estudiante del paso 2
            const fullName = [step2.firstName, step2.firstLastName, step2.secondLastName]
                .filter(Boolean)
                .join(' ');
            
            const initialData = {
                studentName: step5StudentData.studentName || fullName || '',
                rut: step5StudentData.rut || step2.rut || '',
                email: step5StudentData.email || step2.email || '',
                phoneNumber: step5StudentData.phoneNumber || step2.phoneNumber || '',
                birthDate: step5StudentData.birthDate || step2.birthDate || '',
                averageScore: (step5StudentData.averageScore || step2.averageScore || '').replace(/,/g, '.'),
                schoolRegionId: step5StudentData.schoolRegionId || null,
                schoolCommuneId: step5StudentData.schoolCommuneId || null,
                schoolId: step5StudentData.schoolId || null,
                schoolName: step5StudentData.schoolName || null,
                graduationYear: step5StudentData.graduationYear || step2.graduationYear || null,
                authorizationPublicitary: true
            };
            
            
            return initialData;
        },
        beforeDestroy(){
            // Limpiar event listeners específicos de formularios
            const forms = document.querySelectorAll('form, input, select, textarea');
            forms.forEach(element => {
                element.removeEventListener('input', this.resetInactivityTimer);
                element.removeEventListener('change', this.resetInactivityTimer);
                element.removeEventListener('focus', this.resetInactivityTimer);
            });
        }
    }
}
</script>

<style scoped>
.step5-container {
    padding: 20px;
    max-width: 936px;
    margin: 0 auto;
}

.student-form-section {
    margin-top: 3rem;
    position: relative;
}

.student-form-section::before {
    content: '';
    position: absolute;
    top: -1.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    height: 2px;
    background: linear-gradient(90deg, transparent, #e5e7eb, transparent);
}

@media (max-width: 768px) {
    .step5-container {
        padding: 1rem;
    }
    
    .student-form-section {
        margin-top: 2rem;
    }
}

/* Modal Styles */
.modal-step-4 {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    overflow: auto;
}

.modal-content-step4 {
    background-color: #fff;
    width: 90%;
    max-width: 400px;
    padding: 30px;
    border-radius: 15px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    position: relative;
}

@media (max-width: 768px) {
    .modal-content-step4 {
        width: 90%;
        padding: 25px;
    }
}

@media (min-width: 769px) {
    .modal-content-step4 {
        width: 450px;
        padding: 35px;
    }
}

.modal-step-4-header {
    margin-bottom: 15px;
}

.btn-close {
    color: #000;
    font-family: "Poppins-Medium", sans-serif;
    font-size: 20px;
    text-decoration: none;
    font-weight: bold;
}

.otp-div h2 {
    color: #000;
    text-align: center;
    font-family: "Poppins-Bold", sans-serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 20px;
    text-transform: uppercase;
}

.otp-info {
    color: #333;
    text-align: center;
    font-family: "Poppins-Regular", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 25px;
}

.otp-info-email {
    color: #000;
    font-size: 18px;
    font-family: "Poppins-Bold", sans-serif;
    font-weight: 700;
    display: block;
    margin-top: 8px;
}

.otp-info-sent {
    color: #10b981; /* Green color for success message */
    text-align: center;
    font-family: "Poppins-Regular", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    margin-top: 10px;
    margin-bottom: 25px;
}

.otp-div label {
    color: #000;
    font-family: "Poppins-Medium", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
    margin-bottom: 15px;
    display: block;
}

.otp-input-container {
    margin-bottom: 20px;
}

.temporizador {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 25px;
}

.otp-info-clock {
    font-family: "Poppins-Regular", sans-serif;
    font-size: 14px;
    color: #666;
    margin-right: 10px;
}

.otp-clock {
    font-family: "Poppins-Regular", sans-serif;
    font-size: 14px;
    color: #666;
}

.btn-codigo {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}

.error-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
}

.otp-error {
    margin-left: 10px;
    font-family: "Poppins-Regular", sans-serif;
    font-size: 14px;
    color: #ff0000;
    text-align: center;
}

.otp-row-padding {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.input-otp {
    padding: 15px 20px;
    background-color: #ffffff;
    border-radius: 100px;
    border: 2px solid #ddd;
    box-sizing: border-box;
    height: 50px;
    width: 100%;
    max-width: 300px;
    font-size: 18px;
    text-align: center;
    font-family: "Poppins-Regular", sans-serif;
    transition: all 0.3s ease;
}

.input-otp:focus {
    outline: none;
    border-color: #6b46c1;
    box-shadow: 0 0 0 3px rgba(107, 70, 193, 0.1);
}

.input-otp::placeholder {
    color: #999;
}

.boton-new-primario {
    cursor: pointer;
    min-width: 200px;
    height: 50px;
    font-family: "Poppins-Bold", sans-serif;
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: #6b46c1;
    border: none;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
}

.boton-new-primario:hover {
    background: #553c9a;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(107, 70, 193, 0.3);
}

.boton-new-largo {
    width: 100%;
    max-width: 300px;
}

.boton-new-primario.active {
    background: #6b46c1;
    color: #ffffff;
}

.boton-new-primario.active:hover {
    background: #553c9a;
}

.boton-new-primario:disabled {
    background: #ccc !important;
    color: #666 !important;
    cursor: not-allowed !important;
    transform: none !important;
    box-shadow: none !important;
}

.boton-new-primario:disabled:hover {
    background: #ccc !important;
}

.boton-new-primario:disabled.active {
    background: #ccc !important;
    color: #666 !important;
}

.valido {
    border-color: #10b981 !important;
}

.invalido {
    border-color: #ef4444 !important;
}

.danger {
    color: #ef4444;
    font-size: 16px;
}

/* Estilos para el modal de procesamiento */
.modal-intensive {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    z-index: 1000;
    overflow: hidden;
    display: flex;
    align-items: center;
    height: 100vh;
    background: rgba(134, 133, 133, 0.1);
}

.modal-intensive .content {
    position: relative;
    width: 40%;
    border-radius: 24px;
    border: 2px solid #000;
    background: #fff;
    padding: 24px;
    box-shadow: 0 0 12px 3px #00000038;
    min-height: 380px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

@media (max-width: 768px) {
    .modal-intensive .content {
        width: 90%;
    }
}

.modal-intensive .text-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 0 70px;
}

.modal-intensive .text-content h5 {
    color: #000;
    text-align: center;
    font-family: "Poppins-Bold", sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    margin-bottom: 10px;
}

.modal-intensive .text-content p {
    color: #666;
    text-align: center;
    font-family: "Poppins-Regular", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 0px;
}

.img-modal-loading {
    position: absolute;
    right: 20px;
    bottom: 20px;
    height: 70%;
}

@media (max-width: 768px) {
    .img-modal-loading {
        display: none;
    }
}


</style>
